import { FC, ReactNode } from 'react'
import { Box, useMantineColorScheme } from '@mantine/core'

const FullScreenLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const { colorScheme } = useMantineColorScheme()

  const bg = colorScheme === 'dark' ? 'var(--app-background-dark)' : 'var(--app-background)'

  return (
    <Box bg={bg} style={{ height: '100vh' }}>
      {children}
    </Box>
  )
}

export default FullScreenLayout
